import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../auth/authProvider";
import Button from "../../components/Button";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { telemetry } from "../../utils/telemetry/TelemetryService";
import MunicipalityBaseView from "./MunicipalityBaseView";

const MunicipalityAccessError = () => {
    const { signout } = useContext(AuthContext);
    const { authUserData } = useContext(AuthenticatedUserContext);

    useEffect(() => {
        telemetry.trackError(new Error("Municipality Access Error"), {
            uid: authUserData?.uid,
            identityId: authUserData?.identityId,
        });
    }, [authUserData]);

    return (
        <MunicipalityBaseView
            title="Någonting gick fel"
            subTitle="Testa att logga ut och sedan in igen">
            <Button theme={"greenDark"} onClick={signout} title="Logga ut" />
        </MunicipalityBaseView>
    );
};

export default MunicipalityAccessError;
